export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_f05fff24-1793-4250-930b-537d899538c3/artifacts/7ck3tbem_CIEES%20Portugal%20-%20Portugues.png";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900";

export const SHRINE_IMAGE =
  "https://images.unsplash.com/photo-1605641532626-5ab1dab56350?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const MIAMI_IMAGE =
  "https://images.unsplash.com/photo-1535498730771-e735b998cd64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900";

// Wikipedia's main lead photo for the "Lisbon" article — stable Wikimedia
// Commons URL. Iconic panoramic view of Lisbon city.
export const LISBON_IMAGE =
  "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Lisboa_-_Portugal_%2852597836992%29.jpg/1920px-Lisboa_-_Portugal_%2852597836992%29.jpg";
